import { gql } from '@apollo/client';

export const UNLINK_PROVIDER_TO_PATIENT = gql`
  mutation UnlinkPatientWithProvider($data: UnlinkProviderInput!) {
    unlinkPatientWithProvider(data: $data)
  }
`;
